import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { BasketButtonError, NotifyMeError, } from '@as-react/common-types';
import { isEqual } from '@as-react/common-utils';
import { Box, Label, SelectAlpha, useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { usePrevious } from '../../../hooks/usePrevious';
import { mapAndesSizeSelectOptions, selectOptionLabel } from '../../../util/ProductUtil';
import { ScrollUtil } from '../../../util/ScrollUtil';
import { SizeRecommendationV2 } from '../size-recommendation-v2/SizeRecommendationV2';
export const SizeSelectV2 = ({ id, basketValidationState, sizes, selectedSku, selectSize, sizeRecommendation, isOneSizeProduct, isOneSizeProductInline, isModal, openSizeSelectOnError, notifyMeError, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const SIZE_SELECT_NAME = 'size-select';
    const { isShopLanding } = useAemConfig();
    const items = mapAndesSizeSelectOptions(sizes, true, undefined, !isShopLanding);
    const SHOW_ERROR = basketValidationState === BasketButtonError.SKU;
    const [shouldShowError, setShouldShowError] = useState(false);
    const sizeSelectRef = useRef(null);
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const prevSizes = usePrevious(sizes);
    const handleSelect = (item) => {
        setShouldShowError(false);
        selectSize({ sku: String(item.id), isSoldOut: item.strikethrough });
    };
    useEffect(() => {
        if (isOneSizeProduct && selectedSku) {
            selectSize({ sku: selectedSku });
        }
    }, []);
    useEffect(() => {
        if (!isEqual(sizes, prevSizes)) {
            setShouldShowError(false);
        }
    }, [sizes, prevSizes]);
    useEffect(() => {
        if (selectedSku && shouldShowError) {
            setShouldShowError(false);
        }
    }, [selectedSku]);
    useEffect(() => {
        const shouldOpenOnError = openSizeSelectOnError &&
            (basketValidationState === BasketButtonError.SKU_OPEN_SIZE_SELECT || notifyMeError === NotifyMeError.SELECT_SIZE);
        if (shouldOpenOnError) {
            ScrollUtil.scrollToErrorElement(sizeSelectRef.current, isDesktop, () => {
                var _a;
                (_a = sizeSelectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
        else {
            setShouldShowError(SHOW_ERROR);
            if (SHOW_ERROR && basketValidationState === BasketButtonError.SKU) {
                if (isModal) {
                    ScrollUtil.scrollToElement(sizeSelectRef.current, true);
                }
                else {
                    ScrollUtil.scrollToErrorElement(sizeSelectRef.current, isDesktop);
                }
            }
        }
    }, [basketValidationState, notifyMeError]);
    if (isOneSizeProductInline) {
        return (_jsxs(_Fragment, { children: [sizeRecommendation && _jsx(SizeRecommendationV2, { sizeRecommendation: sizeRecommendation }), _jsx(Label, { children: t('pdp.size') }), " ", items.length > 0 && sizes[0] ? selectOptionLabel(sizes[0]) : undefined] }));
    }
    if (isOneSizeProduct) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [sizeRecommendation && _jsx(SizeRecommendationV2, { sizeRecommendation: sizeRecommendation }), _jsx(Box, { flex: { grow: 1 }, paddingBlock: "2", children: _jsx(SelectAlpha, { input: {
                        id: id !== null && id !== void 0 ? id : SIZE_SELECT_NAME,
                        innerRef: sizeSelectRef,
                        label: t('pdp.size'),
                        placeholder: t('pdp.size.choose.default'),
                        error: shouldShowError ? t('pdp.selectSize.label') : undefined,
                        required: true,
                    }, name: SIZE_SELECT_NAME, testId: "size_select", items: items, value: selectedSku || undefined, onSelect: handleSelect }) })] }));
};
